import { TableColumn, ColDataType } from '../../table/DataTable.types';

export const columns: TableColumn[] = [
  {
    accessor: 'rateModel',
    name: 'page.currency-rates.col-rate-model',
  },
  {
    accessor: 'validFrom',
    name: 'page.currency-rates.col-valid-from',
    dataType: ColDataType.DATE,
  },
];
